import React from 'react';
import ButtonBase, { BaseButtonProps } from '../ButtonBase/ButtonBase';

interface Props
  extends Omit<BaseButtonProps, 'href' | 'target' | 'isExternal'> {}

const Button: React.FC<Props> = (props) => <ButtonBase {...props} />;

export default Button;
